const loadingLabel = "Loading";
const enMT = {
  loadingLabel
};
export {
  enMT as default,
  loadingLabel
};
